import { useNavigate } from "react-router-dom";

const ziua1 = [
  "WhatsApp Image 2022-03-21 at 19.48.51.jpeg",
  "WhatsApp Image 2022-03-21 at 19.49.14.jpeg",
  "WhatsApp Image 2022-03-21 at 19.49.35.jpeg",
  "WhatsApp Image 2022-03-21 at 19.49.39.jpeg",
  "WhatsApp Image 2022-03-21 at 19.50.11.jpeg",
  "WhatsApp Image 2022-03-21 at 19.50.12.jpeg",
  "WhatsApp Image 2022-03-21 at 19.50.13.jpeg",
  "WhatsApp Image 2022-03-21 at 19.54.51.jpeg",
];

const ziua2 = [
  "PHOTO-2022-03-22-18-54-37.jpg",
  "PHOTO-2022-03-22-19-19-10 3.jpg",
  "PHOTO-2022-03-22-19-32-04 3.jpg",
  "WhatsApp Image 2022-03-22 at 19.01.21 (1).jpeg",
  "WhatsApp Image 2022-03-22 at 19.01.39.jpeg",
  "WhatsApp Image 2022-03-22 at 19.02.07.jpeg",
  "WhatsApp Image 2022-03-22 at 19.02.45.jpeg",
  "WhatsApp Image 2022-03-22 at 19.04.51.jpeg",
  "WhatsApp Image 2022-03-22 at 19.04.59.jpeg",
  "WhatsApp Image 2022-03-22 at 19.05.12.jpeg",
  "WhatsApp Image 2022-03-22 at 19.05.17.jpeg",
  "WhatsApp Image 2022-03-22 at 19.05.25.jpeg",
  "WhatsApp Image 2022-03-22 at 19.05.30.jpeg",
  "WhatsApp Image 2022-03-22 at 19.05.39.jpeg",
  "WhatsApp Image 2022-03-22 at 19.06.00.jpeg",
];

const ziua3 = [
  "WhatsApp Image 2022-03-23 at 19.31.20.jpeg",
  "WhatsApp Image 2022-03-23 at 19.31.27.jpeg",
  "WhatsApp Image 2022-03-23 at 19.31.59 (1).jpeg",
  "WhatsApp Image 2022-03-23 at 19.32.01.jpeg",
  "WhatsApp Image 2022-03-23 at 19.32.02 (1).jpeg",
  "WhatsApp Image 2022-03-23 at 19.32.50.jpeg",
  "WhatsApp Image 2022-03-23 at 19.32.52.jpeg",
  "WhatsApp Image 2022-03-23 at 19.33.03 (2).jpeg",
  "WhatsApp Image 2022-03-23 at 19.33.03.jpeg",
  "WhatsApp Image 2022-03-23 at 19.33.04 (1).jpeg",
  "WhatsApp Image 2022-03-23 at 19.33.04.jpeg",
  "WhatsApp Image 2022-03-23 at 19.38.11.jpeg",
  "WhatsApp Image 2022-03-23 at 19.47.54.jpeg",
  "WhatsApp Image 2022-03-23 at 19.47.58.jpeg",
  "WhatsApp Image 2022-03-23 at 19.48.05.jpeg",
  "WhatsApp Image 2022-03-23 at 19.48.12.jpeg",
];

const ziua4 = [
  "WhatsApp Image 2022-03-24 at 22.10.57.jpeg",
  "WhatsApp Image 2022-03-24 at 22.11.05.jpeg",
  "WhatsApp Image 2022-03-24 at 22.11.26.jpeg",
  "WhatsApp Image 2022-03-24 at 22.12.33.jpeg",
  "WhatsApp Image 2022-03-24 at 22.13.40.jpeg",
  "WhatsApp Image 2022-03-24 at 22.13.49.jpeg",
  "WhatsApp Image 2022-03-24 at 22.13.53.jpeg",
  "WhatsApp Image 2022-03-24 at 22.13.58.jpeg",
];

const ziua5 = [
  "PHOTO-2022-03-22-18-54-35 2.jpg",
  "WhatsApp Image 2022-03-25 at 12.18.58 (2).jpeg",
  "WhatsApp Image 2022-03-25 at 12.18.59 (3).jpeg",
  "WhatsApp Image 2022-03-25 at 12.19.00 (1).jpeg",
  "WhatsApp Image 2022-03-25 at 12.19.00 (3).jpeg",
  "WhatsApp Image 2022-03-25 at 12.19.07.jpeg",
  "WhatsApp Image 2022-03-25 at 12.19.19.jpeg",
  "WhatsApp Image 2022-03-25 at 12.21.24.jpeg",
  "WhatsApp Image 2022-03-25 at 12.21.35.jpeg",
  "WhatsApp Image 2022-03-25 at 12.21.42.jpeg",
  "WhatsApp Image 2022-03-25 at 12.21.44.jpeg",
  "WhatsApp Image 2022-03-25 at 12.21.45.jpeg",
];

function PhotoGrid({ images, folder }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {images.map((img, idx) => (
        <div
          key={img}
          className="aspect-square overflow-hidden rounded-lg shadow-lg bg-white flex items-center justify-center hover:scale-105 transition-transform duration-200"
        >
          <img
            src={
              `/proiecte/Erasmus+/pozeTurcia/${folder}/${img}`
            }
            alt={`Turcia Erasmus ${idx + 1}`}
            className="object-cover w-full h-full"
          />
        </div>
      ))}
    </div>
  );
}

export default function TurciaPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-4 text-center">
          Întâlnire de lucru în ISTANBUL, TURCIA, în cadrul proiectului Erasmus+
          KA229 „OUR PAST OUR FUTURE“
        </h1>
        <p className="mb-4">
          Reprezentanții Liceului Tehnologic „Dr. Florian Ulmeanu” Ulmeni au
          participat, în perioada 21 -26 martie 2022, la a treia activitate de
          învățare-predare din cadrul proiectului ,,OUR PAST OUR FUTURE”,
          parteneriat strategic în domeniul educațional din cadrul Acțiunii
          cheie KA229, număr de identificare 2019-1-IT02-KA229-062420_5,
          realizat cu sprijinul financiar al Comisiei Europene prin ANPCDEFP.
          Proiectul este un parteneriat între cinci școli din țări diferite,
          precum: Italia, România, Grecia, Letonia și Turcia (țara gazdă a
          acestei întâlniri).
        </p>
        <p className="mb-4">
          Topicul propus de partenerii turci a vizat dezvoltarea și promovarea
          patrimoniului cultural „Parcul Gulhane”. Acest program promovează
          competențele cheie la nivel internațional, în ceea ce privește
          potențialul economic, atragerea turiștilor, precum și creșterea
          nivelului de trai.
        </p>
        <p className="mb-2 font-semibold">Școlile participante:</p>
        <ul className="list-disc ml-6 mb-4">
          <li>
            Instituto D’istruzione Superiore E. Fermi - G. Filangieri, Italia
          </li>
          <li>Dr. Kemal Naci Ek și Anadolu Lisesi, Turcia</li>
          <li>3o Geniko Lykeio Katerinis, Grecia</li>
          <li>Rezekne State Gymnasium No1, Letonia</li>
          <li>Liceul Tehnologic „Dr. Florian Ulmeanu”, Ulmeni, Maramureș</li>
        </ul>
        <p className="mb-4">
          În cadrul proiectului, pe parcursul a cinci zile, au avut loc
          activități de predare–învățare, precum și workshop-uri (business
          game-uri). În prima zi a reuniunii, a fost prezentat programul de
          activități pentru toată perioada. În fiecare zi, s-a desfășurat jocul
          de afaceri în care elevii au lucrat împreună, fiind împărțiți în două
          grupe mixte, pentru realizarea companiilor propuse de țara gazdă:
        </p>
        <p className="mb-2 font-semibold">
          Proposal for a business with reference to Gulhane Park:
        </p>
        <ul className="list-disc ml-6 mb-4">
          <li>A- An organisation company</li>
          <li>B - An escape room</li>
        </ul>
        <p className="mb-4">
          Activitățile incluse în program au fost diverse, a avut loc o
          întâlnire cu oficialitățile orașului, unde ni s-a explicat implicarea
          acestora în școală, susținerea învățământului, a elevilor și a
          profesorilor. O altă activitate interesantă a fost lexiconul, unde
          elevii și profesorii participanți au învățat cuvinte în limba țării
          gazdă. Pe lângă activitățile de antreprenoriat, s-au desfășurat
          excursii tematice care au fost foarte apreciate de către participanți.
        </p>
        <p className="mb-4">
          În ultima zi dedicată întâlnirii din cadrul proiectului, s-a
          desfășurat prezentarea finală a business game-ului și a avut loc
          festivitatea de premiere. Limba de comunicare pe toată durata
          desfășurării activităților a fost engleza.
        </p>
        <p className="mb-4">
          Întâlnirea a fost una fructuoasă, realizându-se toate obiectivele
          propuse pentru această etapă a proiectului, astfel, ERASMUS+ înseamnă
          prietenie, provocare, oameni și curajul de a explora noi orizonturi.
        </p>
        <p className="mb-4">Luni, 21.03.2022</p>
        <PhotoGrid images={ziua1} folder="poze ziua 1" />
        <p className="mb-4">Marți, 22.03.2022</p>
        <PhotoGrid images={ziua2} folder="poze ziua 2" />
        <p className="mb-4">Miercuri, 23.03.2022</p>
        <PhotoGrid images={ziua3} folder="ziua 3" />
        <p className="mb-4">Joi, 24.03.2022</p>
        <PhotoGrid images={ziua4} folder="poze ziua 4" />
        <p className="mb-4">Vineri, 25.03.2022</p>
        <PhotoGrid images={ziua5} folder="ziua a 5-a" />

        <button
          onClick={() => navigate("/proiecte/erasmus+")}
          className="m-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 float-right"
        >
          &larr; Înapoi
        </button>
      </main>
    </div>
  );
}
